import type { TenantCapabilities } from '@/pages/access-admin/tenant/api';

/**
 * In-app pages a notification can link to that only some roles may open, with the identity
 * capabilities their route gates ask for (any of them; routes/index.tsx CapabilityGate). A link
 * to one of them is followed only when the active role holds the capability, so nobody is sent
 * to "no permission" from a notification. Every other in-app page is open to every role.
 */
export const GATED_TARGETS: ReadonlyArray<[string, (keyof TenantCapabilities)[]]> = [
  ['/settings/access-history', ['history']],
  ['/settings/approvals', ['approve', 'my_requests']],
  ['/settings/memberships', ['memberships']],
];

/** May the active role open `path`? While its capabilities are unknown, a gated page is not. */
export function canOpenTarget(path: string, caps: TenantCapabilities | null): boolean {
  const gate = GATED_TARGETS.find(
    ([prefix]) =>
      path === prefix ||
      path.startsWith(`${prefix}/`) ||
      path.startsWith(`${prefix}?`) ||
      path.startsWith(`${prefix}#`),
  );
  if (!gate) return true;
  return Boolean(caps && gate[1].some((c) => caps[c]));
}
